import { EMPTY_COUNTRY, EMPTY_REGION } from '@front-app/components/inputs/CountryPickerData';
import { FullUserOccupation, FullUserOccupationRequest } from '@front-app/services/UserApi/UserModel';

export const toNegOneOrString = (input: null | number): string | null => {
	if (!input) {
		return '-1';
	}
	return input.toString();
};

export function mergeOccupation(updates: Partial<FullUserOccupationRequest>, current: FullUserOccupation): Partial<FullUserOccupationRequest> {
	let employer;
	const employerId = current?.employer?.id;
	if (employerId && employerId !== -1) {
		employer = { id: current?.employer?.id };
	}
	return {
		employer,
		positionTitle: current.positionTitle,
		startMonth: toNegOneOrString(current.startMonth),
		startYear: toNegOneOrString(current.startYear),
		phone: current.phone,
		location: {
			street1: current.location.street1,
			street2: current.location.street2,
			city: current.location.city,
			province: current.location.provStateRegion || EMPTY_REGION,
			country: current.location.country || EMPTY_COUNTRY,
			postal: current.location.postalCode || '',
			contactInfo: {
				phone: current.location.contactInfo.phone,
				extension: current.location.contactInfo.extension,
				mobile: current.location.contactInfo.mobile,
				fax: current.location.contactInfo.fax,
			},
		},
		...updates,
	};
}
